"use client";

import { Box, Button, Grid2, Option, Select, Typography } from "@repo/ui";

import Section from "../components/Section";
import { useSuspenseQuery } from "@apollo/client";
import { GET_TESTIMONIALS } from "@/graphql/queries/testimonials";
import { useState } from "react";
import LearnerCard from "@/components/LearnerCard";

type TestimonialsProps = {
  sectionInfo: PageSections;
  data: {
    heading: string;
    description?: string;
  };
};

export default function Testimonials({ sectionInfo, data }: TestimonialsProps) {
  const [load, setLoad] = useState(6);
  const [filter, setFilter] = useState<"category" | "service" | undefined>();
  const { data: testimonialsData } = useSuspenseQuery(GET_TESTIMONIALS);

  const handleLoadMore = () => {
    setLoad((prevLoad) =>
      testimonialsData.testimonials.length > prevLoad ? prevLoad + 6 : prevLoad
    );
  };

  const handleFilterChange = (value: any) => {
    setFilter(value);
  };

  return (
    <Section id={sectionInfo.sectionId} className={sectionInfo.sectionClass}>
      <Box flex justifyContent="between" className="mb-4">
        <Typography variant="h2">{data.heading}</Typography>

        <Box>
          <Select defaultValue={undefined} onChange={handleFilterChange}>
            <Option value={undefined}>All testimonials</Option>
            <Option value="service">Course testimonials</Option>
            <Option value="category">Category testimonials</Option>
          </Select>
        </Box>
      </Box>
      {data.description && (
        <Box>
          <Typography paragraph className="text-gray-500">
            {data.description}
          </Typography>
        </Box>
      )}
      <Grid2 spacing={5} container className="pt-4">
        {testimonialsData.testimonials
          .filter((item) => {
            if (filter === "service") {
              return item.service !== null;
            }
            if (filter === "category") {
              return item.category !== null;
            }
            return true;
          })
          .slice(0, load)

          .map((testimonial) => (
            <Grid2 size={{ sm: 12, md: 6, lg: 6 }} key={testimonial.id}>
              <LearnerCard
                name={testimonial.userName}
                feedback={testimonial.comments}
                src={testimonial.avatar_img}
                designation={testimonial.jobTitle}
                outlined={true}
                linkedinUrl={testimonial.linkedinUrl}
                facebookUrl={testimonial.facebookUrl}
                twitterUrl={testimonial.twitterUrl}
                instagramUrl={testimonial.instagramUrl}
              />
            </Grid2>
          ))}
      </Grid2>
      <Grid2 item xs={12} sm={12} md={4} lg={4} className="text-center py-8">
        <Button
          variant="outlined"
          color="primary"
          onClick={handleLoadMore}
          disabled={load >= testimonialsData.testimonials.length}
        >
          Load more
        </Button>
      </Grid2>
    </Section>
  );
}
